import React, { createContext, useContext } from 'react';
import { useNotifications } from '../hooks/useNotifications.js';

/**
 * Context to share unified notification state across components.
 * Replaces AlertsContext for the bell icon and notifications page.
 */
export const NotificationsContext = createContext();

/**
 * Provider component for notifications state
 */
export default function NotificationsProvider({ children }) {
  const notificationsState = useNotifications();

  return (
    <NotificationsContext.Provider value={notificationsState}>
      {children}
    </NotificationsContext.Provider>
  );
}

/**
 * Hook to access notifications context
 */
export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotificationsContext must be used within a NotificationsProvider');
  }
  return context;
};
